import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import CustomerAnalyticsComponent from '../components/CustomerAnalyticsComponent';
import 'react-datepicker/dist/react-datepicker.css';
import { validateSession } from '../utils/functions';

class CustomerAnalytics extends Component {

	constructor(){
        const cachedRole = Number(localStorage.getItem('role') || 0);
        super();
        this.state = { checked: !!localStorage.getItem('token'), role: cachedRole }
	}

	async componentDidMount() {
        const role = await validateSession();
        this.setState({ checked: true, role });
    }

	render() {
        if (!this.state.checked) return (<div></div>);
        return (
            <div class="container-fluid">
                <div class="row">
                    <SidebarComponent itemSelected={43} role={this.state.role}/>
                    <main class="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <HeaderComponent title="General" subtitle="Clientes"/>
                            <CustomerAnalyticsComponent/>
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default CustomerAnalytics;
